import React, { useEffect, useState } from "react";
import Footer from "app/pages/module/Footer";
import AuthNavComponent from "app/pages/module/auth/AuthNav";
import { MessageTab } from "./components/MessageTab";
import { CompanyMessage } from "./components/company/CompanyMessage";
import { IndividualMessage } from "./components/individual/IndividualMessage";

export const Message = () => {
  const [tab, settab] = useState("Company");
  const TabHandle = (data: any) => {
    settab(data);
  };

  return (
    <>
      <AuthNavComponent isLoggedin={true}></AuthNavComponent>
      <MessageTab tab={tab} TabHandle={TabHandle}></MessageTab>
      {tab === "Company" && <CompanyMessage />}
      {tab === "Individual" && <IndividualMessage></IndividualMessage>}
      <Footer></Footer>
    </>
  );
};
